import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import html2canvas from 'html2canvas';

// Add event listener for capture requests
window.addEventListener('message', async (event) => {
  // Check if the message is a capture request
  if (event.data && event.data.type === 'captureRequest') {
    try {
      // Capture the entire page instead of just a specific container
      const canvas = await html2canvas(document.documentElement);
      const imageData = canvas.toDataURL('image/png');

      // Send the captured image back to the parent
      window.parent.postMessage({
        type: 'captureResponse',
        imageData: imageData
      }, '*');
    } catch (error) {
      console.error('Error capturing game:', error);
      // Send error message back to parent
      window.parent.postMessage({
        type: 'captureError',
        error: error.message
      }, '*');
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <App />
    </>
);
